module.exports = __webpack_public_path__ + "static/media/05.0794ecc5.jpg";